import React from "react";

import DupontDialog from "../DupontDialog";

import "./index.scss";

export default function CriticalDeleteDialog(props) {
  const { title, description, onDialogClose, isOverlayLoader, type } = props;

  return (
    <DupontDialog
      open={true}
      type={type}
      title={title}
      onClose={onDialogClose}
      customClass="critical-dialog--width"
      isOverlayLoader={isOverlayLoader}
      cancelBtnText={props.cancelBtnText}
      confirmBtnText={props.confirmBtnText}
    >
      <div className="critical-delete-dailog-main">{description}</div>
    </DupontDialog>
  );
}
